import React from 'react';
import { useSelector } from 'react-redux';
import { capitalize } from 'lodash';
import { ReactComponent as SuccessIconSvg } from 'products/nomad_insurance/assets/img/icons/checkmark.svg';
import useVouchers from 'products/nomad_insurance/hooks/useVouchers';
import { CreditInfo } from '../DiscountInfo/styled';

const VoucherInfo = () => {
  const { hasEndDate } = useSelector(
    // @ts-ignore state is not typed
    (state) => state.nomadInsurance.purchaseInsurance.coverage
  );

  const isRecurring = !hasEndDate;

  const { availableVouchers } = useVouchers();

  if (!availableVouchers || availableVouchers.length === 0) return null;

  if (!isRecurring) return null;

  return (
    <CreditInfo>
      <SuccessIconSvg />
      {availableVouchers?.map((voucher: any) => (
        <span key={voucher.id}>
          You will receive an email to redeem your ${voucher.amount}{' '}
          {capitalize(voucher.provider)} credit when you've completed your purchase.
        </span>
      ))}
    </CreditInfo>
  );
};

export default VoucherInfo;
